import Collection from "lib/collection";
import TransactionModel from "../models/payments/transaction";
export default Collection.extend({
    idAttribute: "_id",

    model: TransactionModel,

    url: function () {
        return `/payment-group/${this.parent._id}/transaction`;
    },
});
